module.exports = __webpack_public_path__ + "img/teach-info-bg.5b2db9a1.png";